module.exports = __webpack_public_path__ + "img/ALSi6-AED.92ec85a6.png";